<template>
  <div class="page-layout" :class="layoutScenarioClass">
    <header class="page-header">
      <div class="page-header__main">
        <div class="page-header__left">
          <PageHeader :title="title" :subtitle="subtitle">
            <template v-if="$slots.title" #title>
              <slot name="title" />
            </template>
            <template v-if="$slots.subtitle" #subtitle>
              <slot name="subtitle" />
            </template>
            <template v-if="$slots['title-extra']" #title-extra>
              <slot name="title-extra" />
            </template>
          </PageHeader>

          <!-- Scenario 2: filters below title on the left (when header has action buttons) -->
          <PageFilters
            v-if="hasControls && useStackedFilters"
            class="page-header__fields page-header__fields--below"
          >
            <template v-if="$slots.search" #search>
              <slot name="search" />
            </template>
            <template v-if="$slots.filters" #filters>
              <slot name="filters" />
            </template>
            <slot name="toolbar" />
          </PageFilters>
        </div>

        <!-- Action buttons on the right (same row as title) -->
        <div
          v-if="hasActions"
          class="page-header__right"
          :class="{
            'page-header__actions': !hasControls || useStackedFilters,
            'page-header__toolbar': hasControls && !useStackedFilters,
          }"
        >
          <PageFilters
            v-if="hasControls && !useStackedFilters"
            class="page-header__fields page-header__fields--inline"
          >
            <template v-if="$slots.search" #search>
              <slot name="search" />
            </template>
            <template v-if="$slots.filters" #filters>
              <slot name="filters" />
            </template>
            <slot name="toolbar" />
          </PageFilters>
          <div class="page-header__actions">
            <slot name="actions" />
          </div>
        </div>

        <!-- Scenario 3: filters on the right, same row as title (no header action buttons) -->
        <PageFilters
          v-else-if="hasControls"
          class="page-header__right page-header__fields page-header__fields--inline"
        >
          <template v-if="$slots.search" #search>
            <slot name="search" />
          </template>
          <template v-if="$slots.filters" #filters>
            <slot name="filters" />
          </template>
          <slot name="toolbar" />
        </PageFilters>
      </div>
    </header>
  </div>
</template>

<script>
import PageHeader from "./PageHeader.vue";
import PageFilters from "./PageFilters.vue";

export default {
  name: "PageLayout",
  components: { PageHeader, PageFilters },
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    /**
     * Gradient bar filter placement:
     * - true: filters/search on the left, below the title row (use when #actions has buttons)
     * - false: filters/search on the right, inline with the title row (no header action buttons)
     * - undefined: defaults to true when #actions slot is used, else false
     */
    stackFiltersBelowTitle: { type: Boolean, default: undefined },
  },
  computed: {
    hasControls() {
      return !!(
        this.$slots.search ||
        this.$slots.filters ||
        this.$slots.toolbar
      );
    },
    hasActions() {
      return !!this.$slots.actions;
    },
    useStackedFilters() {
      if (this.stackFiltersBelowTitle !== undefined) {
        return this.stackFiltersBelowTitle;
      }
      return this.hasActions;
    },
    layoutScenarioClass() {
      if (this.useStackedFilters && this.hasControls) {
        return "page-layout--scenario-2";
      }
      if (this.hasActions && this.hasControls && !this.useStackedFilters) {
        return "page-layout--scenario-3";
      }
      if (this.hasActions) {
        return "page-layout--scenario-1";
      }
      if (this.hasControls) {
        return "page-layout--scenario-3";
      }
      return "page-layout--scenario-1";
    },
  },
};
</script>
